import { SpaceXxs, SpaceXs } from "@nxt-costco-com/forge-design-tokens";
const rootContainerStyles = {
  display: "flex",
  flexDirection: "column",
  gap: SpaceXxs
};
const toggleButtonGroupStyles = {
  display: "flex",
  flexDirection: "row",
  gap: SpaceXs
};
export {
  rootContainerStyles,
  toggleButtonGroupStyles
};
